import React from 'react';
/* eslint-disable react/display-name */

var data = {
  title: 'HSBC',
  viewBox: '0 0 92 46',
  svgContent: React.createElement(React.Fragment, null, React.createElement("rect", {
    fill: "#ffffff",
    x: "23",
    y: "0",
    width: "46",
    height: "46"
  }), React.createElement("polygon", {
    fill: "#db0011",
    points: "91.87 23 69 0 69 46"
  }), React.createElement("polygon", {
    fill: "#db0011",
    points: "46 23 69 0 23 0"
  }), React.createElement("polygon", {
    fill: "#db0011",
    points: "0 23 23 46 23 0"
  }), React.createElement("polygon", {
    fill: "#db0011",
    points: "46 23 23 46 69 46"
  }))
};
export default data;